import React from 'react'
import { ImageSources } from '@shared/constants/imageSources'
import { MapMarker } from './styledComponents'

export const Marker = ({ children }) => (
    <MapMarker imgSrc={ImageSources.mapMarkerIco}>{children}</MapMarker>
)
